import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpRequestHandler } from '../../models/http-model';
import { HttpService } from '../http.service';
const HEADERS = {};

@Injectable()
export class LoadPeriodTableService {
  static ENV = environment;

  constructor(private httpService: HttpService) {
    HEADERS['Content-Type'] = 'application/json';
  }

  public savePeriods(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(LoadPeriodTableService.ENV.environment.API.periods, data, httpRequesthandler);
  }

  public loadTables(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(LoadPeriodTableService.ENV.environment.API.load_tables, data, httpRequesthandler);
  }

  public getPeriodsByBook(data: any , httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = 'application/json';
    this.httpService.post(LoadPeriodTableService.ENV.environment.API.get_periods, data, httpRequesthandler);
  }

  public getSchema(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = 'application/json';
    this.httpService.get(LoadPeriodTableService.ENV.environment.API.get_schema,  httpRequesthandler);
  }

  public getTables(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = 'application/json';
    this.httpService.post(LoadPeriodTableService.ENV.environment.API.get_system_tables, data, httpRequesthandler);
  }

  public loadPeriodsWs(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(LoadPeriodTableService.ENV.environment.API.load_periods_ws, data, httpRequesthandler);
  }

  public deletePeriods(data: any, httpRequesthandler: HttpRequestHandler): void {
    let params: string = `year=${data.year}&ledger=${data.ledger_id}&period=${data.period_num}`;
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${LoadPeriodTableService.ENV.environment.API.periods}?${params}`, httpRequesthandler);
  }

  public runReportPeriods(data:any, httpRequestHandler: HttpRequestHandler): void {
    httpRequestHandler.headers = HEADERS;
    this.httpService.post(`${LoadPeriodTableService.ENV.environment.API.run_report_periods}`, data, httpRequestHandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/load-period-table/load-period-table.service.ts